import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export const FloatingWhatsApp = () => {
  const handleClick = () => {
    window.open("https://wa.me/27616850671", "_blank");
  };

  return (
    <Button
      variant="whatsapp"
      size="icon"
      onClick={handleClick}
      className="fixed bottom-6 right-6 h-14 w-14 rounded-full shadow-elevated hover:shadow-2xl z-50 animate-pulse"
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle className="h-6 w-6" />
    </Button>
  );
};
